<template>
  <div
    :class="[
      'container',
      { 'container--top-none': !spacingTop },
      { 'container--bottom-none': !spacingBottom }
    ]"
    data-comp="l-container"
  >
    <slot />
  </div>
</template>

<script setup>
const props = defineProps({
  spacingX: {
    type: String,
    default: ""
  },
  spacingY: {
    type: String,
    default: ""
  },
  spacingTop: {
    type: Boolean,
    default: true
  },
  spacingBottom: {
    type: Boolean,
    default: true
  }
});
</script>

<style lang="scss">
.container {
  display: flex;
  flex-direction: column;
  max-width: var(--max-width-page);
  gap: var(--container-gap-y);
  padding: var(--container-spacing-y) var(--container-spacing-x);
  &--top-none {
    padding-top: 0;
  }
  &--bottom-none {
    padding-bottom: 0;
  }
}
</style>
